import { render } from "./complaints.vue?vue&type=template&id=619ff152&scoped=true"
import script from "./complaints.vue?vue&type=script&lang=js"
export * from "./complaints.vue?vue&type=script&lang=js"

import "./complaints.vue?vue&type=style&index=0&id=619ff152&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619ff152"]])

export default __exports__